<template>
  <div class="goals">
    <img class="goals__icon" src="@/assets/hometeacher/images/bird01.png">
    <header class="goals-header">
      <h3 class="goals-header__title">{{ $t('result') }}:</h3>
      <h4 class="goals-header__subtitle">{{ course.result_header }}:</h4>
    </header>
    <ul class="golas-list">
      <li
        class="goals-list__item"
        v-if="course.result_achiev_val1 && course.result_achiev_name1"
      >
        <span class="goal">
          <span class="goal__counter">{{ course.result_achiev_val1 }}</span>
          {{ course.result_achiev_name1 }}
        </span>
      </li>

      <li
        class="goals-list__item"
        v-if="course.result_achiev_val2 && course.result_achiev_name2"
      >
        <span class="goal">
          <span class="goal__counter">{{ course.result_achiev_val2 }}</span>
          {{ course.result_achiev_name2 }}
        </span>
      </li>

      <li
        class="goals-list__item"
        v-if="course.result_achiev_val3 && course.result_achiev_name3"
      >
        <span class="goal">
          <span class="goal__counter">{{ course.result_achiev_val3 }}</span>
          {{ course.result_achiev_name3 }}
        </span>
      </li>

      <li
        class="goals-list__item"
        v-if="course.result_achiev_val4 && course.result_achiev_name4"
      >
        <span class="goal">
          <span class="goal__counter">{{ course.result_achiev_val4 }}</span>
          {{ course.result_achiev_name4 }}
        </span>
      </li>

      <li
        class="goals-list__item"
        v-if="course.result_achiev_val5 && course.result_achiev_name5"
      >
        <span class="goal">
          <span class="goal__counter">{{ course.result_achiev_val5 }}</span>
          {{ course.result_achiev_name5 }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CourseGoals',

  props: {
    course: Object
  },
}
</script>

<style>
  @media (max-width: 991.8px) {
    .goals {
      margin-right: 15px;
      margin-left: 15px;
    }
  }

  .goals {
    background-color: #5ab947;
    background-image: url(data:image/png;base64,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);
    border-radius: 6px;
    box-shadow: 0 5px 5px rgba(0, 0, 0, .2);
    font-family: 'Manrope Bold', 'Open Sans', sans-serif;
    padding: 20px;
  }
  .goals,
  .goals-header__title  {
    color: rgba(255, 255, 255, .65);
    font-size: 1rem;
    margin-bottom: 0;
  }
  .goals-header__subtitle {
    color: #fff;
    font-size: 1.35rem;
  }
  .golas-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .goal__counter {
    color: #fafd00;
    font-size: 1.5rem;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, .4);
  }
  .goals__icon {
    float: right;
    margin-top: -10px;
  }
</style>
